import * as React from "react";

import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

interface StackDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  statusBadge?: React.ReactNode;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const StackDrawer = ({
  open,
  onOpenChange,
  title,
  subtitle,
  statusBadge,
  headerAction,
  children,
  footer,
  className,
}: StackDrawerProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className={cn(
          "context-drawer-normal w-[90%] max-w-[90%] h-full bg-white p-0 flex flex-col rounded-l-2xl sm:w-full sm:max-w-[600px] sm:rounded-none",
          className,
        )}
        side="right"
      >
        <SheetHeader className="border-b border-border flex-none py-6 px-4 sm:px-6 text-left">
          <div className="flex items-start justify-between gap-3">
            <div className="space-y-1">
              <SheetTitle className="text-xl font-semibold text-foreground">
                {title}
              </SheetTitle>
              {subtitle || statusBadge ? (
                <div className="flex items-center gap-2">
                  {subtitle ? (
                    <SheetDescription className="text-sm text-muted-foreground">
                      {subtitle}
                    </SheetDescription>
                  ) : null}
                  {statusBadge}
                </div>
              ) : null}
            </div>
            {headerAction ? (
              <div className="flex items-center gap-2">
                {headerAction}
              </div>
            ) : null}
          </div>
        </SheetHeader>

        <div className="flex-1 min-h-0 min-w-0 overflow-hidden">
          <ScrollArea className="h-full [&_[data-radix-scroll-area-viewport]>div]:!block [&_[data-radix-scroll-area-viewport]>div]:!min-w-0">
            <div className="py-6 px-4 sm:px-6">{children}</div>
          </ScrollArea>
        </div>

        {footer ? (
          <div className="border-t border-border bg-white flex-none py-6 px-4 sm:px-6">
            {footer}
          </div>
        ) : null}
      </SheetContent>
    </Sheet>
  );
};

export { StackDrawer, type StackDrawerProps };
export default StackDrawer;
